import React from 'react'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import Input from '_/shared/components/input'
import { Row, Col } from 'react-bootstrap'

/**
 * A Table Row that has the ability to edit
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class MetadataInput extends React.Component {
  static propTypes = {
    colSize: React.PropTypes.number,
    field: React.PropTypes.string.isRequired,
    link: React.PropTypes.func.isRequired,
    errors: React.PropTypes.object,
    metadata: React.PropTypes.object.isRequired,
    hasRange: React.PropTypes.bool,
    hasLabel: React.PropTypes.bool,
    placeholder: React.PropTypes.string
  }

  renderText () {
    const { field, link, metadata, errors, hasLabel, placeholder } = this.props

    return (
      <Input
        label={hasLabel && metadata.get('label')}
        name={field}
        type={metadata.get('isMulti') ? 'text-multi' : 'text'}
        errors={errors}
        placeholder={placeholder}
        valueLink={link(field)} />
    )
  }

  renderDate () {
    const { field, link, metadata, errors, hasRange, hasLabel, colSize = 6, placeholder } = this.props

    if (hasRange) {
      return (
        <div>
          <label>{metadata.get('label')}</label>
          <Row>
            <Col xs={colSize}>
              <div className="form-group">
                <Input
                  standalone
                  name={`${field}_start`}
                  type="date"
                  placeholder="Start - mm/dd/yyyy"
                  valueLink={link(`${field}_start`)} />
              </div>
            </Col>
            <Col xs={colSize}>
              <div className="form-group">
                <Input
                  standalone
                  name={`${field}_end`}
                  type="date"
                  placeholder="End - mm/dd/yyyy"
                  valueLink={link(`${field}_end`)} />
              </div>
            </Col>
          </Row>
        </div>
      )
    }

    return (
      <Input
        label={hasLabel && metadata.get('label')}
        name={field}
        type="date"
        errors={errors}
        placeholder={placeholder}
        valueLink={link(field)} />
    )
  }

  renderEmail () {
    const { field, link, metadata, errors, hasLabel, placeholder } = this.props

    return (
      <Input
        label={hasLabel && metadata.get('label')}
        name={field}
        type="email"
        errors={errors}
        placeholder={placeholder}
        valueLink={link(field)} />
    )
  }

  renderTel () {
    const { field, link, metadata, errors, hasLabel, placeholder } = this.props

    return (
      <Input
        label={hasLabel && metadata.get('label')}
        name={field}
        type="tel"
        errors={errors}
        placeholder={placeholder}
        valueLink={link(field)} />
    )
  }

  renderNumber () {
    const { field, link, errors, metadata, hasRange, hasLabel, placeholder } = this.props

    if (hasRange) {
      return (
        <div className="form-group">
          <label>{metadata.get('label')}</label>
          <Row>
            <Col xs={6}>
              <Input
                standalone
                name={`${field}_start`}
                type="number"
                placeholder="Start"
                valueLink={link(`${field}_start`)} />
            </Col>

            <Col xs={6}>
              <Input
                standalone
                name={`${field}_end`}
                type="number"
                placeholder="End"
                valueLink={link(`${field}_end`)} />
            </Col>
          </Row>
        </div>
      )
    }

    return (
      <Input
        label={hasLabel && metadata.get('label')}
        name={field}
        type="number"
        errors={errors}
        placeholder={placeholder}
        valueLink={link(field)} />
    )
  }

  renderCheckbox () {
    const { field, link, metadata, errors, hasLabel } = this.props

    return (
      <Input
        label={hasLabel && metadata.get('label')}
        name={field}
        type="switch"
        errors={errors}
        checkedLink={link(field)} />
    )
  }

  renderTextarea () {
    const { field, link, metadata, errors, hasLabel, placeholder } = this.props

    return (
      <Input
        label={hasLabel && metadata.get('label')}
        name={field}
        type="textarea"
        errors={errors}
        placeholder={placeholder}
        valueLink={link(field)} />
    )
  }

  renderSelect () {
    const { field, link, metadata, errors, hasLabel } = this.props

    return (
      <Input
        label={hasLabel && metadata.get('label')}
        type="select"
        name={field}
        errors={errors}
        multi={!!metadata.get('isMulti')}
        options={metadata.get('enumValues').map(v => {
          return { value: v.get && v.get('value') || v, label: v.get && v.get('label') || v }
        }).toJS()}
        valueLink={link(field)} />
    )
  }

  render() {
    const { metadata } = this.props
    if (!metadata) return null

    switch (metadata.get('inputType')) {
      case 'text':
        return this.renderText()
      case 'date':
        return this.renderDate()
      case 'email':
        return this.renderEmail()
      case 'tel':
        return this.renderTel()
      case 'number':
        return this.renderNumber()
      case 'checkbox':
        return this.renderCheckbox()
      case 'textarea':
        return this.renderTextarea()
      case 'select':
        return this.renderSelect()
    }

    return null
  }
}

export default MetadataInput



// WEBPACK FOOTER //
// ./modules/shared/components/metadataInput.js